import { Text, View } from '@/styles/reactnative';
import { IconSend } from '@tabler/icons-react';
import { useIsMobile } from '@utils/CalVW.tsx';
import {
  Button,
  Col,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Space,
} from 'antd';
import BigNumber from 'bignumber.js';
import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import API from '../../../../utils/api';
import { useToken } from '../../../hooks';
import { useDepositStore } from '../../../hooks/deposit/store';
import { useFetcherPublic } from '../../../hooks/fetcher';
import { useBalance } from '../../../hooks/user/mybalance';
import { useMyProfile } from '../../../hooks/user/myprofile';
import DepositCoins from '../../DepositModal/DepositLeftSection/DepositCoins';
import { DepositLeftSectionWrapper } from '../styles';
import DepositChainType from './DepositChainType';
import WithdrawWalletAddress from './WithdrawWalletAddress';
import styled from 'styled-components';
import { useWithdrawList } from '@app/hooks/wallet/GetWithdrawList.tsx';
import { t } from 'i18next';

const WithdrawLeftSection = ({ width = '100%', setShowModal = (e) => {} }) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { isDarkMode } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';

  const [data, setData] = React.useState('');
  const [verifyState, setVerifyState] = useState(false);
  const [verifyCode, setVerifyCode] = useState('');
  const [uid, setUid] = useState('');
  const [isVerify, setIsVerify] = useState(false);

  const { data: depositStore } = useDepositStore({
    network: 'TRC20',
    coin: 'USDT',
  });

  const [refresh, setRefresh] = useState(false);
  const currencyList = useFetcherPublic('/system/currency');

  const equivusd = currencyList?.data?.result?.result?.find(
    (item: any) => item?.code === 'KRW'
  );

  const { data: balance } = useBalance('USDT', 0);
  const isMobile = useIsMobile();

  const { data: token } = useToken();
  //const [amount, setAmount] = useState(0);
  const [name, setName] = useState('');

  const { data: myprofile } = useMyProfile();
  const { data: balanceData, mutate } = useBalance('KRW', 9);

  // 출금 상태
  const [tokenSymbol, setTokenSymbol] = useState<string>('USDT');
  const [network, setNetwork] = useState<string>('TRC-20');
  const [address, setAddress] = useState<any>(null);
  const [amount, setAmount] = useState<number>(0);
  const [fee, setFee] = useState<number>(0);
  const [note, setNote] = useState<string>('');
  const [renewWithdrawData, setRenewWithdrawData] = useState<any>(null);
  const { WithdrawList } = useWithdrawList();

  useEffect(() => {
    if (WithdrawList) {
      const list: { label: any; value: any }[] = [];

      WithdrawList?.map((data) => {
        list.push({ label: data?.address, value: data?.id });
      });

      setRenewWithdrawData(list);
    }
  }, [WithdrawList]);

  const postWithdrawAddress = async () => {
    if (!address) {
      message.error(t('pleaseEnterRequiredFields'));
      return;
    }

    if (!amount || amount <= 0) {
      message.error(t('pleaseEnterWithdrawAmount'));
      return;
    }

    // 현물지갑 가용잔액 체크
    const availableBalance = new BigNumber(balance?.balance || 0).minus(
      balance?.lockbalance || 0
    );

    if (new BigNumber(amount).isGreaterThan(availableBalance)) {
      message.error(t('insufficientSpotBalance'));
      return;
    }

    try {
      const addressRes = await API.send(
        'POST',
        `/withdraw/check-address`,
        token,
        {
          address,
        }
      );

      if (addressRes?.result?.addressId) {
        const res = await API.send('POST', `/withdraw/request`, token, {
          tokenSymbol,
          addressId: addressRes?.result?.addressId || null,
          amount,
          fee,
          note,
        });

        if (res?.success) {
          message.success(t('withdrawSuccess'));
          setShowModal(false);
        } else {
          console.log('출금 실패 응답:', res);
          message.error(t('withdrawFailed'));
        }
      } else {
        const registWithdrawRes = await API.send(
          'POST',
          `/withdraw/address`,
          token,
          {
            address,
            network,
          }
        );

        if (registWithdrawRes?.success) {
          if (registWithdrawRes?.result?.id) {
            const res = await API.send('POST', `/withdraw/request`, token, {
              tokenSymbol,
              addressId: registWithdrawRes?.result?.id || null,
              amount,
              fee,
              note,
            });

            if (res?.success) {
              message.success(t('withdrawSuccess'));
              setShowModal(false);
            } else {
              console.log('출금 실패 응답 (주소 등록 후):', res);
              message.error(t('widthrawFailed'));
            }
          }
        } else {
          message.error(t('widthrawFailed'));
        }
      }
    } catch (e) {
      console.log(e, '출금 시스템 에러');
    }
  };

  useEffect(() => {
    // console.log('myprofile', myprofile);
    setUid(
      myprofile?.email?.includes('@')
        ? myprofile?.email
        : '+' + myprofile?.email
    );
  }, [myprofile]);

  const available = BigNumber(balanceData?.balance).minus(
    balanceData?.lockbalance
  );

  const [otpCode, setOtpCode] = useState<string>('');

  const twofa = myprofile?.twofa;

  useEffect(() => {
    setTimeout(() => {
      setRefresh(!refresh);
    }, 500);
  }, [depositStore?.coin, depositStore?.network]);

  const handleWithdraw = async () => {
    try {
      if (!isVerify) {
        message.error('Please verify your identity.');
        return;
      }

      if (twofa && !otpCode) {
        message.error('Please enter OTP code.');
        return;
      }

      if (twofa) {
        try {
          const verifyResponse = await API.post(
            '/auth/totp/verify',
            token + '',
            {
              otpValue: otpCode,
            }
          );

          console.log('verifyResponse', verifyResponse);

          if (!verifyResponse?.success) {
            message.error('Invalid OTP code.');
            return;
          }
        } catch (e) {
          message.error('Failed to verify OTP code.');
          return;
        }
      }

      if (myprofile?.level == 6 || myprofile?.level == -8) {
        message.error('Temporary users cannot withdraw money.');
      } else {
        /* empty */
      }
      if (!amount) {
        message.error('Request Amount is required.');
        return;
      }

      if (
        new BigNumber(amount)
          .dividedBy(equivusd?.price)
          .isGreaterThan(
            new BigNumber(balance?.balance || 0).minus(
              balance?.lockbalance || 0
            )
          )
      ) {
        message.error('Insufficient balance.');
        return;
      }

      const response = await API.post('/cash/request', token + '', {
        type: 'W',
        // amount: new BigNumber(amount).dividedBy(equivusd?.price).toFixed(2),
        amount: amount,
        bankaccount: data || 'Temp user',
        name,
        otp: otpCode,
      });

      if (response?.result?.success) {
        message.success('Requested withdrawal successfully.');
      } else {
        message.error(
          response?.result?.message || 'Failed to request withdrawal.'
        );
      }

      setShowModal(false);
    } catch (e) {
      message.error('Failed to request withdrawal.');
    }
  };

  const handleCheckId = async () => {
    try {
      const res = await API.send('POST', `/verification/send`, null, {
        type: uid.includes('@') ? 'email' : 'sms',
        contact: uid,
      });

      // console.log("res", res);
      if (res?.success) {
        setVerifyState(true);
      } else {
        message.error(res?.result?.message || 'ERROR VERIFY SYSTEM');
      }
    } catch (e) {
      console.log(e, 'ERROR VERIFY SYSTEM');
    }
  };

  const handleVerifiedCode = async () => {
    try {
      const res = await API.send('POST', `/verification/verify`, null, {
        type: uid.includes('@') ? 'email' : 'sms',
        contact: uid,
        code: verifyCode,
      });

      // console.log("res", res);
      if (res?.success) {
        setIsVerify(true);
      } else {
        setIsVerify(false);
        message.error(t('verificationCodeError'));
      }
    } catch (e) {
      message.error(t('verificationCodeError'));
    }
  };

  return (
    <DepositLeftSectionWrapper style={{ width: isMobile ? '100%' : width }}>
      <View style={{ paddingInline: 15, paddingBlock: 10, gap: 30 }}>
        <InputWrap>
          <InputLabel isDarkMode={isDarkMode}>
            <Text size={14}>* {t('crypto')}</Text>
          </InputLabel>
          <StyledSelect
            isDarkMode={isDarkMode}
            options={[{ label: 'USDT', value: 'USDT' }]}
            value={tokenSymbol}
            onChange={(value) => setTokenSymbol(value as string)}
          />
        </InputWrap>

        <InputWrap>
          <InputLabel isDarkMode={isDarkMode}>
            <Text size={14}>* {t('network')}</Text>
          </InputLabel>
          <StyledSelect
            isDarkMode={isDarkMode}
            options={[{ label: 'TRC-20', value: 'TRC-20' }]}
            value={network}
            onChange={(value) => setNetwork(value as string)}
          />
        </InputWrap>

        <InputWrap>
          <InputLabel isDarkMode={isDarkMode}>
            <Text size={14}>* {t('withdrawAddress')}</Text>
          </InputLabel>
          <StyledInput
            isDarkMode={isDarkMode}
            value={address}
            placeholder={t('selectAddress')}
            onChange={(e) => setAddress(e.target.value)}
          />
        </InputWrap>

        <InputWrap>
          <InputLabel isDarkMode={isDarkMode}>
            <Text size={14}>{t('withdrawAmount')}</Text>
          </InputLabel>
          <StyledInput
            isDarkMode={isDarkMode}
            type={'number'}
            value={amount}
            onChange={(e) => setAmount(Number(e.target.value))}
            suffix={tokenSymbol}
          />
        </InputWrap>

        {/*<InputWrap>*/}
        {/*  <InputLabel>*/}
        {/*    {t('fee')}*/}
        {/*  </InputLabel>*/}
        {/*  <StyledInput type={'number'} value={fee} onChange={(e) => setFee(Number(e.target.value))} />*/}
        {/*</InputWrap>*/}

        <InputWrap>
          <InputLabel isDarkMode={isDarkMode}>
            <Text size={14}>{t('description')}</Text>
          </InputLabel>
          <StyledInput
            isDarkMode={isDarkMode}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </InputWrap>

        {/*<DepositCoins />*/}

        {/*{depositStore?.coin !== 'KRW' && (*/}
        {/*  <>*/}
        {/*    <DepositChainType />*/}
        {/*    <WithdrawWalletAddress data={data} setData={setData} />*/}
        {/*  </>*/}
        {/*)}*/}

        {/*{depositStore?.coin === 'KRW' ? (*/}
        {/*  <Space*/}
        {/*    style={{*/}
        {/*      flexDirection: 'column',*/}
        {/*      alignItems: 'flex-start',*/}
        {/*      marginBottom: 20,*/}
        {/*      width: '100%',*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <Row align={'middle'} style={{ marginBottom: 10 }}>*/}
        {/*      <Col*/}
        {/*        span={isMobile ? 10 : 6}*/}
        {/*        style={{*/}
        {/*          color: textw,*/}
        {/*          marginBottom: isMobile ? 10 : undefined,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Request Amount*/}
        {/*      </Col>*/}
        {/*      <Col span={isMobile ? 23 : 13}>*/}
        {/*        <InputNumber*/}
        {/*          value={amount}*/}
        {/*          formatter={(value) =>*/}
        {/*            `${value}`*/}
        {/*              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')*/}
        {/*              ?.replace(/[^0-9,]/g, '')*/}
        {/*          }*/}
        {/*          parser={(value: any) =>*/}
        {/*            value!.replace(/\$\s?|(,*)/g, '')?.replace(/[^0-9]/g, '')*/}
        {/*          }*/}
        {/*          step={10}*/}
        {/*          onChange={(e: any) =>*/}
        {/*            setAmount(*/}
        {/*              Math.min(*/}
        {/*                parseInt(available.toNumber() + ''),*/}
        {/*                +BigNumber(e).toFixed(0)*/}
        {/*              )*/}
        {/*            )*/}
        {/*          }*/}
        {/*          style={{*/}
        {/*            textAlign: 'right',*/}
        {/*            width: '100%',*/}
        {/*            flex: 1,*/}
        {/*          }}*/}
        {/*        />*/}
        {/*      </Col>*/}
        {/*      <Col span={1} style={{ color: textw, marginLeft: 0 }}>*/}
        {/*        $*/}
        {/*      </Col>*/}
        {/*      <Col*/}
        {/*        span={isMobile ? 12 : 4}*/}
        {/*        style={{ marginBlock: isMobile ? 10 : undefined }}*/}
        {/*      >*/}
        {/*        <Button*/}
        {/*          size="small"*/}
        {/*          // style={{ padding: 0, marginLeft: 5 }}*/}
        {/*          onClick={() => {*/}
        {/*            setAmount(0);*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          RESET*/}
        {/*        </Button>*/}
        {/*      </Col>*/}
        {/*    </Row>*/}
        {/*    <Row*/}
        {/*      align={'middle'}*/}
        {/*      style={{*/}
        {/*        width: '100%',*/}
        {/*        flex: 1,*/}
        {/*        marginBottom: 20,*/}
        {/*        paddingBottom: 20,*/}
        {/*        borderBottom: '1px solid #999',*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Col*/}
        {/*        span={24}*/}
        {/*        style={{*/}
        {/*          width: '100%',*/}
        {/*          display: 'flex',*/}
        {/*          flex: 1,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        <Space.Compact*/}
        {/*          size={'small'}*/}
        {/*          style={{ flex: 1, width: '100%', gap: isMobile ? 10 : 0 }}*/}
        {/*          // direction={isMobile ? 'vertical' : 'horizontal'}*/}
        {/*        >*/}
        {/*          <Button*/}
        {/*            size="small"*/}
        {/*            style={{ width: '100%', flex: 1 }}*/}
        {/*            onClick={() => {*/}
        {/*              const max = new BigNumber(*/}
        {/*                BigNumber(balance?.balance || 0).minus(*/}
        {/*                  balance?.lockbalance || 0*/}
        {/*                )*/}
        {/*              ).minus(1);*/}
        {/*              setAmount(max.toNumber());*/}
        {/*            }}*/}
        {/*          >*/}
        {/*            +MAX*/}
        {/*          </Button>*/}
        {/*          <Button*/}
        {/*            size="small"*/}
        {/*            style={{ width: '100%', flex: 1 }}*/}
        {/*            onClick={() => {*/}
        {/*              setAmount(amount + 1000);*/}
        {/*            }}*/}
        {/*          >*/}
        {/*            +1000$*/}
        {/*          </Button>*/}
        {/*          <Button*/}
        {/*            size="small"*/}
        {/*            style={{ width: '100%', flex: 1 }}*/}
        {/*            onClick={() => {*/}
        {/*              setAmount(amount + 500);*/}
        {/*            }}*/}
        {/*          >*/}
        {/*            +500$*/}
        {/*          </Button>*/}
        {/*          <Button*/}
        {/*            size="small"*/}
        {/*            style={{ width: '100%', flex: 1 }}*/}
        {/*            onClick={() => {*/}
        {/*              setAmount(amount + 100);*/}
        {/*            }}*/}
        {/*          >*/}
        {/*            +100$*/}
        {/*          </Button>*/}
        {/*          <Button*/}
        {/*            size="small"*/}
        {/*            style={{ width: '100%', flex: 1 }}*/}
        {/*            onClick={() => {*/}
        {/*              setAmount(amount + 5);*/}
        {/*            }}*/}
        {/*          >*/}
        {/*            +5$*/}
        {/*          </Button>*/}

        {/*          {!isMobile && (*/}
        {/*            <Button*/}
        {/*              size="small"*/}
        {/*              style={{ width: '100%', flex: 1 }}*/}
        {/*              onClick={() => {*/}
        {/*                setAmount(amount + 1);*/}
        {/*              }}*/}
        {/*            >*/}
        {/*              +1$*/}
        {/*            </Button>*/}
        {/*          )}*/}
        {/*        </Space.Compact>*/}
        {/*      </Col>*/}

        {/*      {isMobile && (*/}
        {/*        <Button*/}
        {/*          size="small"*/}
        {/*          style={{ width: '100%', flex: 1, marginTop: 10 }}*/}
        {/*          onClick={() => {*/}
        {/*            setAmount(amount + 1);*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          +1$*/}
        {/*        </Button>*/}
        {/*      )}*/}
        {/*    </Row>*/}

        {/*    /!* <Row align={'middle'}>*/}
        {/*			<Col span={6} style={{ color: textw }}>*/}
        {/*				환산금액*/}
        {/*			</Col>*/}
        {/*			<Col*/}
        {/*				span={18}*/}
        {/*				style={{*/}
        {/*					flexDirection: 'row',*/}
        {/*					display: 'flex',*/}
        {/*					alignItems: 'center',*/}
        {/*				}}>*/}
        {/*				<Input*/}
        {/*					type="text"*/}
        {/*					style={{*/}
        {/*						flex: 1,*/}
        {/*						color: new BigNumber(amount)*/}
        {/*							.dividedBy(equivusd?.price)*/}
        {/*							?.isGreaterThan(*/}
        {/*								BigNumber(*/}
        {/*									balance?.balance || 0*/}
        {/*								).minus(*/}
        {/*									balance?.lockbalance ||*/}
        {/*										0*/}
        {/*								)*/}
        {/*							)*/}
        {/*							? COLORS.darkRed*/}
        {/*							: COLORS.primary,*/}
        {/*					}}*/}
        {/*					value={new BigNumber(amount)*/}
        {/*						.dividedBy(equivusd?.price)*/}
        {/*						.toFixed(2)}*/}
        {/*					readOnly></Input>{' '}*/}
        {/*				<div style={{ color: textw }}>USDT</div>*/}
        {/*			</Col>*/}
        {/*		</Row> *!/*/}
        {/*    <Row align={'middle'}>*/}
        {/*      <Col span={6} style={{ color: textw }}>*/}
        {/*        Avaliable Amount*/}
        {/*      </Col>*/}
        {/*      <Col*/}
        {/*        span={18}*/}
        {/*        style={{*/}
        {/*          flexDirection: 'row',*/}
        {/*          display: 'flex',*/}
        {/*          alignItems: 'center',*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        <Input*/}
        {/*          type="text"*/}
        {/*          style={{ flex: 1 }}*/}
        {/*          value={new BigNumber(balance?.balance || 0)*/}
        {/*            .minus(balance?.lockbalance || 0)*/}
        {/*            .toFormat(2)}*/}
        {/*          readOnly*/}
        {/*        ></Input>{' '}*/}
        {/*        <div style={{ color: textw }}>USDT</div>*/}
        {/*      </Col>*/}
        {/*    </Row>*/}
        {/*    <span style={{ color: 'orange', fontSize: 12 }}>*/}
        {/*      * Available amount is calculated based on the Spot Wallet*/}
        {/*      balance.*/}
        {/*    </span>*/}
        {/*    /!* <Row align={'middle'}>*/}
        {/*			<Col span={6} style={{ color: textw }}>*/}
        {/*				환율*/}
        {/*			</Col>*/}
        {/*			<Col span={18}>*/}
        {/*				<Input*/}
        {/*					type="text"*/}
        {/*					value={equivusd?.price?.toFixed(2)}*/}
        {/*					readOnly></Input>*/}
        {/*			</Col>*/}
        {/*		</Row> *!/*/}
        {/*  </Space>*/}
        {/*) : depositStore?.coin === 'USDT' ? (*/}
        {/*  <Space*/}
        {/*    style={{*/}
        {/*      flexDirection: 'column',*/}
        {/*      alignItems: 'flex-start',*/}
        {/*      marginBottom: 20,*/}
        {/*      width: '100%',*/}
        {/*      marginTop: 15,*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <Row align={'middle'} style={{ marginBottom: 10 }}>*/}
        {/*      <Col*/}
        {/*        span={isMobile ? 10 : 6}*/}
        {/*        style={{*/}
        {/*          color: textw,*/}
        {/*          marginBottom: isMobile ? 10 : undefined,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Amount (USDT)*/}
        {/*      </Col>*/}
        {/*      <Col span={isMobile ? 23 : 17}>*/}
        {/*        <InputNumber*/}
        {/*          value={amount}*/}
        {/*          formatter={(value) =>*/}
        {/*            `${value}`*/}
        {/*              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')*/}
        {/*              ?.replace(/[^0-9,.]/g, '')*/}
        {/*          }*/}
        {/*          parser={(value: any) =>*/}
        {/*            value!.replace(/\$\s?|(,*)/g, '')?.replace(/[^0-9.]/g, '')*/}
        {/*          }*/}
        {/*          step={0.1}*/}
        {/*          onChange={(e: any) =>*/}
        {/*            setAmount(*/}
        {/*              Math.min(*/}
        {/*                parseFloat(available.toNumber() + ''),*/}
        {/*                +BigNumber(e).toFixed(2)*/}
        {/*              )*/}
        {/*            )*/}
        {/*          }*/}
        {/*          style={{*/}
        {/*            textAlign: 'right',*/}
        {/*            width: '100%',*/}
        {/*            flex: 1,*/}
        {/*          }}*/}
        {/*        />*/}
        {/*      </Col>*/}
        {/*    </Row>*/}

        {/*    <Row align={'middle'} style={{ width: '100%', marginBottom: 20 }}>*/}
        {/*      <Space.Compact*/}
        {/*        size={'small'}*/}
        {/*        style={{ flex: 1, width: '100%', gap: isMobile ? 10 : 0 }}*/}
        {/*      >*/}
        {/*        <Button*/}
        {/*          size="small"*/}
        {/*          style={{ width: '100%', flex: 1 }}*/}
        {/*          onClick={() => {*/}
        {/*            const max = new BigNumber(*/}
        {/*              BigNumber(balance?.balance || 0).minus(*/}
        {/*                balance?.lockbalance || 0*/}
        {/*              )*/}
        {/*            ).minus(0.1);*/}
        {/*            setAmount(max.toNumber());*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          MAX*/}
        {/*        </Button>*/}
        {/*        <Button*/}
        {/*          size="small"*/}
        {/*          style={{ width: '100%', flex: 1 }}*/}
        {/*          onClick={() => setAmount(amount + 100)}*/}
        {/*        >*/}
        {/*          +100*/}
        {/*        </Button>*/}
        {/*        <Button*/}
        {/*          size="small"*/}
        {/*          style={{ width: '100%', flex: 1 }}*/}
        {/*          onClick={() => setAmount(amount + 10)}*/}
        {/*        >*/}
        {/*          +10*/}
        {/*        </Button>*/}
        {/*        <Button*/}
        {/*          size="small"*/}
        {/*          style={{ width: '100%', flex: 1 }}*/}
        {/*          onClick={() => setAmount(amount + 1)}*/}
        {/*        >*/}
        {/*          +1*/}
        {/*        </Button>*/}
        {/*      </Space.Compact>*/}
        {/*    </Row>*/}
        {/*  </Space>*/}
        {/*) : null}*/}

        <ModernButton
          type="primary"
          icon={<IconSend size={14} />}
          onClick={postWithdrawAddress}
          isDarkMode={isDarkMode}
        >
          출금
        </ModernButton>

        {/*<Space*/}
        {/*  style={{*/}
        {/*    flexDirection: 'column',*/}
        {/*    alignItems: 'flex-start',*/}
        {/*    marginBottom: 20,*/}
        {/*    width: '100%',*/}
        {/*    marginTop: 20,*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <Row align={'middle'} style={{ width: '100%' }}>*/}
        {/*    <Col span={isMobile ? 10 : 6} style={{ color: textw }}>*/}
        {/*      Email / Phone*/}
        {/*    </Col>*/}
        {/*    <Col span={isMobile ? 15 : 11}>*/}
        {/*      <Input*/}
        {/*        value={uid}*/}
        {/*        // onChange={(e) => setUid(e.target.value)}*/}
        {/*        placeholder="Enter Email / Phone"*/}
        {/*        style={{ width: '100%' }}*/}
        {/*      />*/}
        {/*    </Col>*/}
        {/*    <Col*/}
        {/*      span={isMobile ? 6 : 6}*/}
        {/*      style={{*/}
        {/*        marginLeft: isMobile ? 5 : 10,*/}
        {/*        marginTop: isMobile ? 0 : 0,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Button*/}
        {/*        style={{ width: '100%' }}*/}
        {/*        disabled={verifyState}*/}
        {/*        onClick={() => handleCheckId()}*/}
        {/*      >*/}
        {/*        Send Code*/}
        {/*      </Button>*/}
        {/*    </Col>*/}
        {/*  </Row>*/}
        {/*</Space>*/}

        {verifyState && (
          <Space
            style={{
              flexDirection: 'column',
              alignItems: 'flex-start',
              marginBottom: 20,
              width: '100%',
              marginTop: 0,
            }}
          >
            <Row align={'middle'} style={{ width: '100%' }}>
              <Col span={isMobile ? 10 : 6} style={{ color: textw }}>
                {t('verifyCode')}
              </Col>
              <Col span={isMobile ? 15 : 11}>
                <Input
                  value={verifyCode}
                  onChange={(e) => setVerifyCode(e.target.value)}
                  placeholder={t('verifyCode')}
                  maxLength={6}
                  style={{ width: '100%' }}
                />
              </Col>
              <Col span={isMobile ? 6 : 6} style={{ marginLeft: 10 }}>
                {isVerify ? (
                  <div style={{ color: 'green' }}>{t('success')}</div>
                ) : (
                  <Button onClick={() => handleVerifiedCode()}>
                    {t('verify')}
                  </Button>
                )}
              </Col>
            </Row>
          </Space>
        )}

        {/* {!!twofa && (
          <Space
            style={{
              flexDirection: 'column',
              alignItems: 'flex-start',
              marginBottom: 20,
              width: '100%',
              marginTop: 0,
            }}
          >
            <Row align={'middle'} style={{ width: '100%' }}>
              <Col span={isMobile ? 10 : 6} style={{ color: textw }}>
                OTP Code
              </Col>
              <Col span={isMobile ? 23 : 17}>
                <Input
                  value={otpCode}
                  onChange={(e) => setOtpCode(e.target.value)}
                  placeholder="Enter OTP code"
                  maxLength={6}
                  style={{ width: '100%' }}
                />
              </Col>
            </Row>
          </Space>
        )} */}
      </View>
    </DepositLeftSectionWrapper>
  );
};

export default WithdrawLeftSection;

const InputWrap = styled.div`
  margin-bottom: 20px;
  width: 100%;
  max-width: 500px;
`;

const InputLabel = styled.label<{ isDarkMode: boolean }>`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) =>
    props.isDarkMode ? '#FFFFFF' : '#212121'}; // theme.light.COLORS.itemTitle
  margin-bottom: 10px;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.9;
`;

const StyledInput = styled(Input)<{ isDarkMode: boolean }>`
  width: 100%;
  height: 42px;
  background: ${(props) =>
    props.isDarkMode
      ? 'rgba(40, 40, 40, 0.8)'
      : '#F0F1F8'} !important; // 다크: 기존, 라이트: CardBg
  border: 2px solid
    ${(props) => (props.isDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#C8D6EF')} !important; // 다크: 기존, 라이트: CardBorder
  border-radius: 12px !important;
  padding: 0 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: ${(props) => (props.isDarkMode ? '#FFFFFF' : '#212121')} !important;
  transition: all 0.3s ease !important;

  &::placeholder {
    color: ${(props) => (props.isDarkMode ? '#7F8C8D' : '#616161')} !important;
    font-weight: 400 !important;
  }

  &:hover,
  &:focus {
    border-color: #007aff !important;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.2) !important;
    transform: translateY(-1px);
  }
`;

const StyledSelect = styled(Select)<{ isDarkMode: boolean }>`
  width: 100%;

  .ant-select-selector {
    height: 42px !important;
    background: ${(props) =>
      props.isDarkMode
        ? 'rgba(40, 40, 40, 0.8)'
        : '#F0F1F8'} !important; // 다크: 기존, 라이트: CardBg
    border: 2px solid
      ${(props) => (props.isDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#C8D6EF')} !important; // 다크: 기존, 라이트: CardBorder
    border-radius: 12px !important;
    padding: 0 16px !important;
    transition: all 0.3s ease !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-item {
    color: ${(props) => (props.isDarkMode ? '#FFFFFF' : '#212121')} !important;
    font-weight: 500 !important;
    line-height: 38px !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-search {
    display: flex !important;
    align-items: center !important;
  }

  &:hover .ant-select-selector,
  &.ant-select-focused .ant-select-selector {
    border-color: #007aff !important;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.2) !important;
    transform: translateY(-1px);
  }

  .ant-select-arrow {
    color: ${(props) => (props.isDarkMode ? '#FFFFFF' : '#212121')} !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-top: 0 !important;
  }
`;

const ModernButton = styled(Button)<{ isDarkMode: boolean }>`
  width: 100%;
  max-width: 500px;
  height: 48px;
  margin-top: 20px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #007aff 0%, #33a7ff 100%);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);

  &:hover {
    background: linear-gradient(135deg, #33a7ff 0%, #85d8ff 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 122, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(0, 122, 255, 0.3);
  }

  .anticon {
    margin-right: 8px;
  }
`;
